import Grid from '../../../share/grid/Grid.vue'
import Page from '../../../../share/content/Page'
import NewPoliceUnitModal from './modal/NewPoliceUnit.vue'
import ActionButton from '@/components/bundles/share/grid/ActionButton'

export default {
  template: `
    <div>
        <section class="content">
            <div class="row">
                <div class="col-sm-12">
                    <div class="box box-default box-solid">
                        <div class="box-body table-responsive">
                            <grid :source="gridDataSource"
                                  :name="gridName"
                                  :columns="gridColumns"
                                  :actions="gridActions"
                                  :defaultOrder="[[1, 'asc']]"
                                  @show="actionShow">
                            </grid>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <new-policeUnit-modal :show="modalPoliceUnitVisible"
                    @close="modalPoliceUnitVisible = false"
                    mode="new"
                    :service="service">
        </new-policeUnit-modal>
    </div>`,
  components: {
    Grid,
    NewPoliceUnitModal
  },
  mixins: [
    Page
  ],
  data () {
    return {
      events: {
        addPoliceUnit: 'core:policeUnit:addPoliceUnit'
      },
      gridActions: [
        { id: 0, event: 'show', title: 'Szczegóły', icon: 'folder-open', acl: { service: 'core', action: 'get_police_unit' } }
      ],
      modalPoliceUnitVisible: false
    }
  },
  mounted () {
    this.$events.on(this.events.addPoliceUnit, this.addPoliceUnit)
  },
  computed: {
    gridDataSource () {
      const vm = this
      return { service: vm.service, url: '/police' }
    },
    gridColumns() {
      return [
        {
          id: 0,
          data: 'DT_RowId',
          title: '',
          searchable: false,
          orderable: false,
          render: (data, type, row) => {
            return ActionButton.renderActionButtons(data, type, row, this.gridActions, this)
          }
        },
        { id: 1, data: 'label', title: 'Nazwa' },
        { id: 2, data: 'city', title: 'Miejscowość' },
        { id: 3, data: 'postcode', title: 'Kod pocztowy' },
        { id: 4, data: 'voivodeship', title: 'Województwo' }
      ]
    }
  },
  methods: {
    addPoliceUnit () {
      this.modalPoliceUnitVisible = true
    },
    actionShow (id) {
      const vm = this
      this.$router.push({ name: vm.actionShowUrlName, params: { id } })
    }
  }
}
